'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedThread = undefined;

var _reselect = require('reselect');

var _getThreads = require('../../threads/selectors/getThreads');

var _getSelectedThreadId = require('./getSelectedThreadId');

var getSelectedThread = exports.getSelectedThread = (0, _reselect.createSelector)([_getThreads.getThreads, _getSelectedThreadId.getSelectedThreadId], function (threads, selectedThreadId) {
  if (!threads) {
    return null;
  }

  return threads.get(selectedThreadId) || null;
});